module.exports = __webpack_public_path__ + "img/left-arm.82654f3e.svg";